import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import Button from '../Button/Button';
import {
  HeaderActionsLeft,
  HeaderActionsRight,
  Header,
  HeaderTitle,
  HeaderContent,
  SettingsButton
} from './PageHeader.style';
import debounce from '../../libs/debounce';
import NavigationHistory from '../../libs/NavigationHistory';
import {
  capture,
  PH_SETTINGS_CLICKED,
  PH_NOTIFICATION_CENTER_CLICKED
} from '../../libs/posthogAnalytics';

const HeaderContainerVariants = {
  enter: { opacity: 1, transition: { duration: 0.6, ease: 'easeOut' } },
  exit: { opacity: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

export default class HomePageHeader extends React.Component {
  static renderOrganizationLogo() {
    return (
      <div className="organization-logo">
        <img src="/logo-96.png" tw="w-32 h-32" width="32" height="32" alt="" />
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.handleClickOnNameAndSettingsButton = debounce(
      this.handleClickOnNameAndSettingsButton.bind(this)
    );
    this.handleNotificationsIconClick = debounce(
      this.handleNotificationsIconClick.bind(this)
    );
  }

  handleClickOnNameAndSettingsButton() {
    const { navigationHistory, linkUrlFor } = this.props;
    capture(PH_SETTINGS_CLICKED);
    navigationHistory.goTo(linkUrlFor('/settings'));
  }

  handleNotificationsIconClick() {
    const { navigationHistory, linkUrlFor } = this.props;
    capture(PH_NOTIFICATION_CENTER_CLICKED);
    navigationHistory.goTo(linkUrlFor('/notifications'));
  }

  renderNameAndSettingsButton() {
    const { user } = this.props;
    return (
      <SettingsButton onClick={this.handleClickOnNameAndSettingsButton}>
        <span tw="truncate">{user.name}</span>
      </SettingsButton>
    );
  }

  renderNotificationsButton() {
    const { rosternotifications, timesheetnotifications, updatenotifications } = this.props;
    const hasUnreadNotifications =
      rosternotifications.hasUnreadNotifications() ||
      timesheetnotifications.hasUnreadNotifications() ||
      updatenotifications.hasUnreadNotifications();
    return (
      <Button
        contentType="icon"
        size="medium"
        color={hasUnreadNotifications ? 'primary' : 'default'}
        icon={hasUnreadNotifications ? 'notification' : 'notification-empty'}
        onClick={this.handleNotificationsIconClick}
        dataAttributes={{
          'data-test-button': 'notifications'
        }}
      />
    );
  }

  renderHomepageHeader() {
    return (
      <Header $fixed>
        <HeaderContent>
          <HeaderActionsLeft $paddingLeft={16}>
            <div tw="flex">
              {this.constructor.renderOrganizationLogo()}
              {this.renderNameAndSettingsButton()}
            </div>
          </HeaderActionsLeft>
          <HeaderActionsRight $paddingRight={12}>
            {this.renderNotificationsButton()}
          </HeaderActionsRight>
        </HeaderContent>
      </Header>
    );
  }

  render() {
    return (
      <motion.div
        key="home"
        variants={HeaderContainerVariants}
        exit="exit"
        animate="enter"
      >
        {this.renderHomepageHeader()}
      </motion.div>
    );
  }
}

HomePageHeader.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    host: PropTypes.string
  }).isRequired,
  rosternotifications: PropTypes.shape({
    hasUnreadNotifications: PropTypes.func
  }).isRequired,
  updatenotifications: PropTypes.shape({
    hasUnreadNotifications: PropTypes.func
  }).isRequired,
  linkUrlFor: PropTypes.func.isRequired,
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired
};

HomePageHeader.defaultProps = {
  navs: []
};
